import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { GatedDownloadModal } from './components/GatedDownloadModal';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Framework } from './pages/Framework';
import { Resources } from './pages/Resources';
import { Insights } from './pages/Insights';
import { Contact } from './pages/Contact';
const GUIDE_TITLE = 'The MGS Toolkit';
export function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [resourceTitle, setResourceTitle] = useState(GUIDE_TITLE);
  const openDownload = (title: string = GUIDE_TITLE) => {
    setResourceTitle(title);
    setModalOpen(true);
  };
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-full w-full bg-cream font-sans text-charcoal" data-id="element-2">
        <Header onDownload={() => openDownload()} data-id="element-3" />

        <main data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home onDownload={openDownload} data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<About onDownload={() => openDownload()} data-id="element-9" />} data-id="element-8" />
            <Route path="/framework" element={<Framework onDownload={openDownload} data-id="element-11" />} data-id="element-10" />
            <Route path="/resources" element={<Resources onDownload={openDownload} data-id="element-13" />} data-id="element-12" />
            <Route path="/insights" element={<Insights data-id="element-15" />} data-id="element-14" />
            <Route path="/contact" element={<Contact onDownload={() => openDownload()} data-id="element-17" />} data-id="element-16" />
          </Routes>
        </main>

        <Footer onDownload={() => openDownload()} data-id="element-18" />
        <StickyMobileCTA onDownload={() => openDownload()} data-id="element-19" />

        <GatedDownloadModal open={modalOpen} resourceTitle={resourceTitle} onClose={() => setModalOpen(false)} data-id="element-20" />
      </div>
    </BrowserRouter>;
}